/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type DeckPitchSelfPublishDetailStatusEnum =
  | 'declaration'
  | 'details'
  | 'sign_declaration'
  | 'sign_declaration_progress'
  | 'accepted'
  | 'rejected'
  | '11184809';

export const DeckPitchSelfPublishDetailStatusEnum = {
  DECLARATION: 'declaration' as DeckPitchSelfPublishDetailStatusEnum,
  DETAILS: 'details' as DeckPitchSelfPublishDetailStatusEnum,
  SIGN_DECLARATION: 'sign_declaration' as DeckPitchSelfPublishDetailStatusEnum,
  SIGN_DECLARATION_PROGRESS: 'sign_declaration_progress' as DeckPitchSelfPublishDetailStatusEnum,
  ACCEPTED: 'accepted' as DeckPitchSelfPublishDetailStatusEnum,
  REJECTED: 'rejected' as DeckPitchSelfPublishDetailStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as DeckPitchSelfPublishDetailStatusEnum
};
